import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import variables from "theme/styles/_variables.module.scss";

export type ChartNumberSkeletonProps = {
  minHeight?: number;
};

const pulse = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 0.6; }
  100% { opacity: 0.3; }
`;

const float = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
  100% { transform: translateY(0); }
`;

const ChartNumberSkeleton: React.FC<ChartNumberSkeletonProps> = (props) => {
  const minHeight = props.minHeight ?? 160;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: minHeight,
        minHeight,
        p: 2,
        gap: 1.25,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: variables.skeletonPaper,
          animation: `${float} 3s ease-in-out infinite`,
        }}
      />

      <Box
        sx={{
          width: 200,
          maxWidth: "85%",
          height: 20,
          borderRadius: 1,
          backgroundColor: variables.skeletonPaper,
          animation: `${pulse} 2s ease-in-out 0.15s infinite`,
        }}
      />

      <Box
        sx={{
          width: 180,
          maxWidth: "75%",
          height: 12,
          borderRadius: 1,
          backgroundColor: variables.skeletonPaper,
          animation: `${pulse} 2s ease-in-out 0.3s infinite`,
        }}
      />
    </Box>
  );
};

export default ChartNumberSkeleton;
